import useTrackPageView from '../../../utils/useTrackPageView';

const PageViewTrigger = () => {
  useTrackPageView();
  return null;
};

export default PageViewTrigger;
